import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/mock' : '/api',
  timeout: 100000,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});


// Retry configuration
const maxRetries = 3;

instance.interceptors.response.use(response => {
  // Just return the response if it's successful
  return response;
}, error => {
  const config = error.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(error);

  // Set the retry count or increase it
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total retries
  if (config.__retryCount >= maxRetries) {
    return Promise.reject(error);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000 * config.__retryCount);  // Exponential back-off delay of retry
  });

  // Return the promise in which axios retry the request
  return backoff.then(() => {
    return instance(config);
  });
});

export default instance;
